import { css } from '@emotion/react';
import { breakpoints, flex, themed } from '@spotnana/blocks/src/utils';

export const illustration_container = themed(
  ({ palette }) => css`
    display: none;

    ${breakpoints.from('desktop')} {
      ${flex.init}
      ${flex.justify.end}
      position: relative;
      margin-top: 4rem;
      max-height: 42rem;

      .image_container {
        position: relative;
        max-height: 42rem;
        border-radius: 1.5rem 0 0 1.5rem;
        border: 2px solid ${palette.bg.buttonDisabled};
        border-right: 0;
        max-width: 100%;
        padding: 2rem;
      }
    }
  `,
);
